import { SVGProps } from "react";

export function CheckMarkIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.16639 2.22173C8.27526 2.29432 8.35084 2.40718 8.37651 2.5355C8.40217 2.66381 8.37581 2.79706 8.30323 2.90594L5.01376 7.84015C4.97325 7.90084 4.91978 7.95178 4.8572 7.98932C4.79463 8.02685 4.72451 8.05004 4.65189 8.05722C4.57928 8.06439 4.50598 8.05537 4.43727 8.0308C4.36856 8.00624 4.30616 7.96674 4.25455 7.91515L2.28087 5.94147C2.19371 5.84793 2.14626 5.72422 2.14851 5.59639C2.15077 5.46856 2.20255 5.34659 2.29296 5.25619C2.38336 5.16579 2.50532 5.114 2.63315 5.11175C2.76098 5.10949 2.8847 5.15694 2.97823 5.2441L4.52626 6.79212L7.48218 2.35791C7.55488 2.24915 7.66779 2.1737 7.79609 2.14817C7.9244 2.12263 8.05759 2.14909 8.16639 2.22173Z"
        fill="white"
      />
    </svg>

  );
}
